import { render, staticRenderFns } from "./VideoAndMaterialsView.vue?vue&type=template&id=5f7befea&scoped=true"
import script from "./VideoAndMaterialsView.vue?vue&type=script&lang=js"
export * from "./VideoAndMaterialsView.vue?vue&type=script&lang=js"
import style0 from "./VideoAndMaterialsView.vue?vue&type=style&index=0&id=5f7befea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f7befea",
  null
  
)

export default component.exports